import OrderInspectionForm from './OrderInspectionForm';

export default OrderInspectionForm;
